import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DraggableButton from '@components/draggable/DraggableButton';
import { stripePriceConverter } from '@services/transform';

const ButtonWrapper = styled(DraggableButton)`
  position: relative;
  @media screen and (min-width: 1024px) {
    align-self: stretch;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    align-self: stretch;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  @media screen and (max-width: 767px) {
    flex: 1;
    margin-right: 16px;
    &:last-child {
      margin-right: 0px;
    }
  }
`;

function AddonSelector(props) {
  const { data, addonType, price, ...restProps } = props;
  const { title, icon } = data;

  return (
    <ButtonWrapper
      key={addonType}
      title={title}
      subtitle={`$${stripePriceConverter(price)}`}
      icon={icon}
      iconColor="gold"
      {...restProps}
    />
  );
}

AddonSelector.propTypes = {
  data: PropTypes.object,
  addonType: PropTypes.string.isRequired,
  price: PropTypes.number
};

export default AddonSelector;
